const ACTIVATION_TIMEOUT_MS = 10_000;

function waitForServiceWorkerActivation(
  registration: ServiceWorkerRegistration
): Promise<ServiceWorkerRegistration> {
  if (registration.active) {
    return Promise.resolve(registration);
  }

  const worker = registration.installing ?? registration.waiting;
  if (!worker) {
    return Promise.reject(new Error('PUSH_SW_NO_WORKER'));
  }

  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      reject(new Error('PUSH_SW_TIMEOUT'));
    }, ACTIVATION_TIMEOUT_MS);

    worker.addEventListener('statechange', () => {
      if (worker.state === 'activated') {
        window.clearTimeout(timeout);
        resolve(registration);
      } else if (worker.state === 'redundant') {
        window.clearTimeout(timeout);
        reject(new Error('PUSH_SW_REDUNDANT'));
      }
    });
  });
}

/** Return the active PWA service worker registration for push, or null on failure. */
export async function getPushRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    if (!registration.active) {
      return await waitForServiceWorkerActivation(registration);
    }
    return registration;
  } catch (err) {
    console.warn('Push service worker unavailable:', err);
    return null;
  }
}

export function isPushSupported(): boolean {
  return (
    typeof window !== 'undefined' &&
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  );
}
